const WORKOUTS_DOMAIN = 'workouts'

export default WORKOUTS_DOMAIN
